import React from 'react';
import classnames from 'classnames';

import classes from './TrustPilot.scss';

type Props = {
    smallWidget?: boolean;
    theme?: 'light' | 'dark';
};

export const TrustPilot: React.FC<Props> = ({ theme = 'light' }) => {
    return (
        <div
            className={classnames(
                classes.trustpilot,
                theme === 'light' && classes.light,
                theme === 'dark' && classes.dark,
            )}
        >
            <span className={classes.trustpilotBrand}>
                <span className={classes.trustpilotBrandStar} aria-hidden="true">
                    &#9733;
                </span>
                Trustpilot
            </span>
            <span className={classes.trustpilotStars} aria-hidden="true">
                <span>&#9733;</span>
                <span>&#9733;</span>
                <span>&#9733;</span>
                <span>&#9733;</span>
                <span className={classes.trustpilotStarMuted}>&#9733;</span>
            </span>
        </div>
    );
};
